export default "__VITE_ASSET__DORuT5iQ__"